import React from "react";
import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";
import TextComboInput from "@shared/v2/TextComboInput";

class ExpenseInput extends React.Component {
  constructor(props) {
    super(props);
    const { isPercentage, disableFlip } = props;

    this.state = {
      isPercentage,
      disableFlip,
      inputSymbol: isPercentage ? "%" : "$",
    };
  }

  setInputType = (isPercentage) => {
    this.setState({ isPercentage, inputSymbol: isPercentage ? "%" : "$" });
  };

  UNSAFE_componentWillReceiveProps = (newProps) => {
    this.setInputType(!!newProps.isPercentage);
  };

  render() {
    const { label, value, name, onValueUpdate, onRadioUpdate } = this.props;
    const { disableFlip, inputSymbol, isPercentage } = this.state;

    return (
      <div className="tw-flex tw-flex-col tw-gap-[8px]">
        <TextComboInput
          label={label}
          trailing={isPercentage ? inputSymbol : ""}
          leading={isPercentage ? "" : inputSymbol}
          value={value}
          onChange={(e) => onValueUpdate(e)}
          size={1}
        />

        {!disableFlip && (
          <div className="tw-flex tw-gap-[16px]">
            <RadioButton
              label="Percent"
              checked={isPercentage}
              name={name}
              value="true"
              onChange={(e) => {
                this.setInputType(true);
                onRadioUpdate(e);
              }}
            />

            <RadioButton
              label="Flat"
              checked={!isPercentage}
              name={name}
              value="false"
              onChange={(e) => {
                this.setInputType(false);
                onRadioUpdate(e);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

ExpenseInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isPercentage: PropTypes.bool,
  disableFlip: PropTypes.bool,
  onValueUpdate: PropTypes.func.isRequired,
  onRadioUpdate: PropTypes.func.isRequired,
};

ExpenseInput.defaultProps = {
  isPercentage: false,
  disableFlip: false,
};

export default ExpenseInput;
